/* eslint-disable react/prop-types */
/* eslint-disable react/function-component-definition */

import PropTypes from "prop-types";

// @mui material components
import Card from "@mui/material/Card";
import Icon from "@mui/material/Icon";

// Material Dashboard 2 React components
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";

// Material Dashboard 2 React example components
import TimelineItem from "examples/Timeline/TimelineItem";

function OrdersOverview({ data }) {
  const { monthlyChangePercent, items } = data;

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox pt={3} px={3}>
        <MDTypography variant="h6" fontWeight="medium">
          Orders overview
        </MDTypography>
        <MDBox mt={0} mb={2}>
          <MDTypography variant="button" color="text" fontWeight="regular">
            <MDTypography display="inline" variant="body2" verticalAlign="middle">
              <Icon sx={{ color: ({ palette: { success } }) => success.main }}>arrow_upward</Icon>
            </MDTypography>
            &nbsp;
            <MDTypography variant="button" color="text" fontWeight="medium">
              {monthlyChangePercent}%
            </MDTypography>{" "}
            this month
          </MDTypography>
        </MDBox>
      </MDBox>
      <MDBox p={2}>
        {items.map((item, index) => (
          <TimelineItem
            key={`${item.title}-${item.dateTime}`}
            color={item.color}
            icon={item.icon}
            title={item.title}
            dateTime={item.dateTime}
            lastItem={index === items.length - 1}
          />
        ))}
      </MDBox>
    </Card>
  );
}

OrdersOverview.propTypes = {
  data: PropTypes.shape({
    monthlyChangePercent: PropTypes.number,
    items: PropTypes.arrayOf(
      PropTypes.shape({
        color: PropTypes.string,
        icon: PropTypes.string,
        title: PropTypes.string,
        dateTime: PropTypes.string,
      })
    ),
  }),
};

OrdersOverview.defaultProps = {
  data: { monthlyChangePercent: 24, items: [] },
};

export default OrdersOverview;
